/**
 * Static assets shared with the meal plan app (served from /public).
 * header-bg.jpg + logos are deployed on orders.getsquarefare.com today.
 */
const publicUrl = process.env.PUBLIC_URL || '';

export const LANDING_ASSETS = {
  headerBg: `${publicUrl}/header-bg.jpg`,
};
